import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Header from '../components/layout/Header';
import NavigationButton from '../components/layout/Navigation';
import { Link } from 'react-router-dom';
import CurrencyInput from '../components/common/CurrencyInput';
import { formatCurrency, parseCurrency } from '../utils/formatters';
import CKEditorComponent from '../components/common/CKEditor';
import ProductPromoModal from '../components/modals/ProductPromoModal';
import QuickStockEditModal from '../components/modals/QuickStockEditModal';
import { getNextDateFromDays } from '../utils/dateUtils';

const DashboardSinergySellersPage = () => {
    const { t, i18n } = useTranslation();
    const [products, setProducts] = useState([]);
    const [vouchers, setVouchers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('list'); // 'list' | 'add' | 'edit' | 'voucher'
    const [productSearch, setProductSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('all'); // 'all' | 'low_stock' | 'out_of_stock' | 'preorder' | 'promo'
    const [storeUrlCopied, setStoreUrlCopied] = useState(false);
    const [isPromoModalOpen, setIsPromoModalOpen] = useState(false);
    const [isQuickStockModalOpen, setIsQuickStockModalOpen] = useState(false);
    const [selectedPromoProduct, setSelectedPromoProduct] = useState(null);
    const [editingProduct, setEditingProduct] = useState(null);
    const [description, setDescription] = useState('');
    const [unit, setUnit] = useState('pcs');
    const [variants, setVariants] = useState([{name: '', additional_price: 0, stock: 0}]);
    const [selectedCouriers, setSelectedCouriers] = useState(['jne', 'pos', 'tiki', 'jnt']);
    const [isCodAvailable, setIsCodAvailable] = useState(false);
    const [isShippingCostActive, setIsShippingCostActive] = useState(false);
    const [shippingCostType, setShippingCostType] = useState('flat'); // 'flat' | 'distance'
    const [shippingCost, setShippingCost] = useState(0);
    const [manualStock, setManualStock] = useState(0);
    const [manualPrice, setManualPrice] = useState(0);
    const [manualPurchasePrice, setManualPurchasePrice] = useState(0);
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [thumbnailPreview, setThumbnailPreview] = useState(null);
    const [galleryFiles, setGalleryFiles] = useState([]);
    const [galleryPreviews, setGalleryPreviews] = useState([]);

    // Jam Operasional, Pre-Order & Pengantaran
    const [isOperationalHoursActive, setIsOperationalHoursActive] = useState(false);
    const [operationalHours, setOperationalHours] = useState('');
    const [isPreorder, setIsPreorder] = useState(false);
    const [preorderType, setPreorderType] = useState('days'); // 'days' | 'range'
    const [preorderDays, setPreorderDays] = useState([]);
    const [preorderDaysMin, setPreorderDaysMin] = useState('');
    const [preorderDaysMax, setPreorderDaysMax] = useState('');
    const [preorderDuration, setPreorderDuration] = useState('');
    const [isDeliveryScheduleActive, setIsDeliveryScheduleActive] = useState(false);
    const [deliveryScheduleType, setDeliveryScheduleType] = useState('range');
    const [deliveryRangeMin, setDeliveryRangeMin] = useState('');
    const [deliveryRangeMax, setDeliveryRangeMax] = useState('');
    const [deliveryDays, setDeliveryDays] = useState([]);
    const [deliveryDate, setDeliveryDate] = useState('');
    const [deliveryNote, setDeliveryNote] = useState('');

    // Ongkir Khusus Luar Jam PO & Fleksibilitas Pengiriman
    const [outOfPoShippingActive, setOutOfPoShippingActive] = useState(false);
    const [outOfPoShippingType, setOutOfPoShippingType] = useState('flat'); // 'flat' | 'distance'
    const [outOfPoShippingCost, setOutOfPoShippingCost] = useState(0);
    const [allowDeliveryTimingChoice, setAllowDeliveryTimingChoice] = useState(false);

    // Pengaturan Operasional & PO Toko vs Custom Produk
    const [useStoreOperationalSettings, setUseStoreOperationalSettings] = useState(true);
    const [sellerProfile, setSellerProfile] = useState(null);


    // Custom bank account state
    const [ownBankStatus, setOwnBankStatus] = useState('none');
    const [ownBankName, setOwnBankName] = useState('');
    const [ownBankAccount, setOwnBankAccount] = useState('');
    const [ownBankHolder, setOwnBankHolder] = useState('');
    const [ownQrisImage, setOwnQrisImage] = useState(null);
    const [ownQrisImagePreview, setOwnQrisImagePreview] = useState(null);
    const [useOwnBank, setUseOwnBank] = useState(false);
    const [origDetails, setOrigDetails] = useState({});

    const getMediaUrl = (url) => {
        if (!url) return null;
        if (url.startsWith('http')) return url;
        return `${process.env.REACT_APP_API_BASE_URL || ''}${url}`;
    };

    const resetBankStates = () => {
        setOwnBankStatus('none');
        setOwnBankName('');
        setOwnBankAccount('');
        setOwnBankHolder('');
        setOwnQrisImage(null);
        setOwnQrisImagePreview(null);
        setUseOwnBank(false);
        setOrigDetails({});
    };

    // Transfer Ownership state
    const [transferModalProduct, setTransferModalProduct] = useState(null);
    const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
    const [transferTargetUser, setTransferTargetUser] = useState('');
    const [transferLoading, setTransferLoading] = useState(false);
    const [transferError, setTransferError] = useState('');
    const [transferSuccess, setTransferSuccess] = useState('');

    const openTransferModal = (product) => {
        setTransferModalProduct(product);
        setTransferTargetUser('');
        setTransferError('');
        setTransferSuccess('');
        setIsTransferModalOpen(true);
    };

    const handleTransferOwnershipSubmit = async (e) => {
        e.preventDefault();
        if (!transferTargetUser.trim() || !transferModalProduct) return;
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user || !user.access) return;

        try {
            setTransferLoading(true);
            setTransferError('');
            setTransferSuccess('');

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/products/${transferModalProduct.id}/transfer-ownership/`,
                { target_user: transferTargetUser.trim() },
                { headers: { Authorization: `Bearer ${user.access}` } }
            );

            setTransferSuccess(response.data.message || 'Kepemilikan produk berhasil dipindahkan!');
            setTimeout(() => {
                setIsTransferModalOpen(false);
                setTransferModalProduct(null);
                fetchDashboardData();
            }, 1800);
        } catch (err) {
            console.error("Transfer ownership error", err);
            const msg = err.response?.data?.error || err.response?.data?.message || 'Gagal memindahkan kepemilikan produk.';
            setTransferError(msg);
        } finally {
            setTransferLoading(false);
        }
    };


    const [pendingOrdersCount, setPendingOrdersCount] = useState(0);

    const fetchDashboardData = async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) return;
        try {
            const productRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/products/?manage=true`, {
                headers: { Authorization: `Bearer ${user.access}` }
            });
            // Lock products display strictly to logged in seller
            const allProds = productRes.data || [];
            const myProds = allProds.filter(p => {
                const sId = p.seller?.id || p.seller_id || p.seller;
                return String(sId) === String(user.id);
            });
            setProducts(myProds);

            const voucherRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/products/vouchers/`, {
                headers: { Authorization: `Bearer ${user.access}` }
            });
            setVouchers(voucherRes.data);

            // Fetch pending incoming orders count for red badge counter
            const ordersRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/orders/seller-orders/`, {
                headers: { Authorization: `Bearer ${user.access}` }
            });
            const newOrders = (ordersRes.data || []).filter(o => {
                const s = (o.status || '').toLowerCase();
                return s === 'pending' || s === 'paid' || s === 'unpaid' || s === 'menunggu';
            });
            setPendingOrdersCount(newOrders.length);

            // Fetch seller profile for global operational settings
            try {
                const profileRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/profiles/me/`, {
                    headers: { Authorization: `Bearer ${user.access}` }
                });
                setSellerProfile(profileRes.data);
            } catch (pErr) {
                console.error("Failed fetching seller profile:", pErr);
            }
        } catch (error) {
            console.error("Failed fetching E-commerce dashboard data", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const handleEdit = (product) => {
        setEditingProduct(product);
        setDescription(product.description || '');
        setUnit(product.unit || 'pcs');
        setVariants(product.variations && product.variations.length > 0 
            ? product.variations.map(v => ({ ...v, additional_price: parseCurrency(v.additional_price) || 0 }))
            : [{name: '', additional_price: 0, stock: 0}]
        );
        setSelectedCouriers(product.supported_couriers ? product.supported_couriers.split(',') : ['jne', 'pos', 'tiki', 'jnt']);
        setIsCodAvailable(product.is_cod_available || false);
        setIsShippingCostActive(product.is_shipping_cost_active || false);
        setShippingCost(parseCurrency(product.shipping_cost) || 0);
        setManualStock(product.stock || 0);
        setManualPrice(parseCurrency(product.price) || 0);
        setManualPurchasePrice(parseCurrency(product.purchase_price) || 0);

        setUseStoreOperationalSettings(product.use_store_operational_settings !== undefined && product.use_store_operational_settings !== null ? Boolean(product.use_store_operational_settings) : true);
        setIsOperationalHoursActive(product.is_operational_hours_active || false);
        setOperationalHours(product.operational_hours || '');
        setIsPreorder(product.is_preorder || false);
        setPreorderDaysMin(product.preorder_days_min !== null && product.preorder_days_min !== undefined ? product.preorder_days_min : '');
        setPreorderDaysMax(product.preorder_days_max !== null && product.preorder_days_max !== undefined ? product.preorder_days_max : '');
        setPreorderDuration(product.preorder_duration || '');
        setIsDeliveryScheduleActive(product.is_delivery_schedule_active || false);
        setDeliveryScheduleType(product.delivery_schedule_type || 'range');
        setDeliveryRangeMin(product.delivery_range_min !== null && product.delivery_range_min !== undefined ? product.delivery_range_min : '');
        setDeliveryRangeMax(product.delivery_range_max !== null && product.delivery_range_max !== undefined ? product.delivery_range_max : '');
        setDeliveryDays(product.delivery_days ? product.delivery_days.split(',').map(s => s.trim()).filter(Boolean) : []);
        setDeliveryDate(product.delivery_date || '');
        setDeliveryNote(product.delivery_note || '');
        setOutOfPoShippingActive(product.out_of_po_shipping_active || false);
        setOutOfPoShippingCost(parseCurrency(product.out_of_po_shipping_cost) || 0);
        setAllowDeliveryTimingChoice(product.allow_delivery_timing_choice !== undefined && product.allow_delivery_timing_choice !== null ? Boolean(product.allow_delivery_timing_choice) : false);

        const detailsObj = {
            own_bank_status: product.own_bank_status || 'none',
            own_bank_name: product.own_bank_name || '',
            own_bank_account: product.own_bank_account || '',
            own_bank_holder: product.own_bank_holder || '',
            own_qris_image: product.own_qris_image || null
        };
        setOrigDetails(detailsObj);
        setOwnBankStatus(detailsObj.own_bank_status);
        setOwnBankName(detailsObj.own_bank_name);
        setOwnBankAccount(detailsObj.own_bank_account);
        setOwnBankHolder(detailsObj.own_bank_holder);
        setOwnQrisImagePreview(getMediaUrl(detailsObj.own_qris_image));
        setUseOwnBank(detailsObj.own_bank_status !== 'none');

        setActiveTab('edit');
    };


    const addVariant = () => {
        setVariants([...variants, {name: '', additional_price: 0, stock: 0}]);
    };

    const removeVariant = (index) => {
        setVariants(variants.filter((_, i) => i !== index));
    };

    const updateVariant = (index, field, value) => {
        const newVariants = [...variants];
        newVariants[index][field] = value;
        setVariants(newVariants);
    };

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

    const validateImageFile = (file) => {
        if (!file) return false;
        if (file.size > MAX_FILE_SIZE) {
            alert(`Ukuran file "${file.name}" terlalu besar. Maksimal 5MB.`);
            return false;
        }
        const ext = file.name.split('.').pop().toLowerCase();
        const validExts = ['jpg', 'jpeg', 'png', 'webp'];
        const validMimes = ['image/jpeg', 'image/png', 'image/webp'];
        if (!validExts.includes(ext) && !validMimes.includes(file.type)) {
            alert(`Format file "${file.name}" tidak didukung. Harap upload gambar berformat JPG, JPEG, PNG, atau WebP.`);
            return false;
        }
        return true;
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!validateImageFile(file)) {
                e.target.value = '';
                return;
            }
            setThumbnailFile(file);
            setThumbnailPreview(URL.createObjectURL(file));
        }
    };

    const handleGalleryChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 5) {
            alert('Maksimal 5 foto galeri');
            e.target.value = '';
            return;
        }

        // Validate each file size and format (.jpg)
        for (const file of files) {
            if (!validateImageFile(file)) {
                e.target.value = '';
                return;
            }
        }

        setGalleryFiles(files);
        setGalleryPreviews(files.map(file => URL.createObjectURL(file)));
    };

    const [savingProduct, setSavingProduct] = useState(false);

    const handleSaveProduct = async (e) => {
        e.preventDefault();
        if (savingProduct) return;
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user || !user.access) return;

        try {
            setSavingProduct(true);
            const formData = new FormData();
            formData.append('title', e.target.title.value);
            formData.append('description', description);
            formData.append('unit', unit || 'pcs');
            formData.append('purchase_price', parseCurrency(e.target.purchase_price.value));
            formData.append('price', parseCurrency(e.target.price.value));
            formData.append('stock', e.target.stock.value);
            formData.append('weight', e.target.weight ? e.target.weight.value : 1000);
            formData.append('category', e.target.category ? e.target.category.value : 'lainnya');
            formData.append('supported_couriers', selectedCouriers.length > 0 ? selectedCouriers.join(',') : 'bebas');
            formData.append('is_cod_available', isCodAvailable);
            formData.append('is_shipping_cost_active', isShippingCostActive);
            formData.append('shipping_cost_type', isShippingCostActive ? shippingCostType : 'flat');
            formData.append('shipping_cost', isShippingCostActive && shippingCostType === 'flat' ? (parseCurrency(shippingCost) || 0) : 0);
            formData.append('purchase_instructions', e.target.purchase_instructions ? e.target.purchase_instructions.value : '');

            formData.append('use_store_operational_settings', useStoreOperationalSettings);
            formData.append('is_operational_hours_active', isOperationalHoursActive);
            formData.append('operational_hours', isOperationalHoursActive ? operationalHours : '');

            formData.append('is_preorder', isPreorder);
            if (isPreorder) {
                formData.append('preorder_type', preorderType);
                if (preorderType === 'days') {
                    formData.append('preorder_days', Array.isArray(preorderDays) ? preorderDays.join(', ') : preorderDays);
                    let durationLabel = preorderDuration;
                    if (!durationLabel && preorderDays.length > 0) {
                        durationLabel = `Setiap ${preorderDays.join(', ')}`;
                    }
                    formData.append('preorder_duration', durationLabel || '');
                } else if (preorderType === 'range') {
                    if (preorderDaysMin !== '') formData.append('preorder_days_min', preorderDaysMin);
                    if (preorderDaysMax !== '') formData.append('preorder_days_max', preorderDaysMax);
                    let durationLabel = preorderDuration;
                    if (!durationLabel && (preorderDaysMin || preorderDaysMax)) {
                        if (preorderDaysMin && preorderDaysMax) {
                            durationLabel = `${preorderDaysMin} - ${preorderDaysMax} Hari`;
                        } else {
                            durationLabel = `${preorderDaysMin || preorderDaysMax} Hari`;
                        }
                    }
                    formData.append('preorder_duration', durationLabel || '');
                }
            } else {
                formData.append('preorder_type', 'days');
                formData.append('preorder_days', '');
                formData.append('preorder_duration', '');
            }

            formData.append('is_delivery_schedule_active', isDeliveryScheduleActive);
            if (isDeliveryScheduleActive) {
                formData.append('delivery_schedule_type', deliveryScheduleType);
                if (deliveryScheduleType === 'range') {
                    if (deliveryRangeMin !== '') formData.append('delivery_range_min', deliveryRangeMin);
                    if (deliveryRangeMax !== '') formData.append('delivery_range_max', deliveryRangeMax);
                } else if (deliveryScheduleType === 'days') {
                    formData.append('delivery_days', Array.isArray(deliveryDays) ? deliveryDays.join(', ') : deliveryDays);
                } else if (deliveryScheduleType === 'date') {
                    if (deliveryDate) formData.append('delivery_date', deliveryDate);
                }
                formData.append('delivery_note', deliveryNote || '');
            }

            formData.append('out_of_po_shipping_active', outOfPoShippingActive);
            formData.append('out_of_po_shipping_type', outOfPoShippingActive ? outOfPoShippingType : 'flat');
            formData.append('out_of_po_shipping_cost', outOfPoShippingActive && outOfPoShippingType === 'flat' ? (parseCurrency(outOfPoShippingCost) || 0) : 0);
            formData.append('allow_delivery_timing_choice', allowDeliveryTimingChoice);

            let targetStatus = ownBankStatus;
            if (!useOwnBank) {
                targetStatus = 'none';
            } else if (ownBankStatus === 'none' || ownBankStatus === 'rejected') {
                targetStatus = 'pending';
            } else {
                if (
                    ownBankName !== (origDetails.own_bank_name || '') ||
                    ownBankAccount !== (origDetails.own_bank_account || '') ||
                    ownBankHolder !== (origDetails.own_bank_holder || '') ||
                    ownQrisImage !== null
                ) {
                    targetStatus = 'pending';
                }
            }
            formData.append('own_bank_status', targetStatus);
            if (useOwnBank) {
                formData.append('own_bank_name', ownBankName);
                formData.append('own_bank_account', ownBankAccount);
                formData.append('own_bank_holder', ownBankHolder);
                if (ownQrisImage) {
                    formData.append('own_qris_image', ownQrisImage);
                }
            } else {
                formData.append('own_bank_name', '');
                formData.append('own_bank_account', '');
                formData.append('own_bank_holder', '');
            }
            
            if (thumbnailFile) {
                formData.append('thumbnail', thumbnailFile);
            }

            galleryFiles.forEach(file => {
                formData.append('gallery_images', file);
            });
            
            const sanitizedVariants = variants.map(v => ({
                ...v,
                additional_price: parseCurrency(v.additional_price) || 0,
                stock: parseInt(v.stock, 10) || 0
            }));
            formData.append('variations', JSON.stringify(sanitizedVariants));

            if (editingProduct) {
                await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/products/${editingProduct.id}/?manage=true`, formData, {
                    headers: { 'Authorization': `Bearer ${user.access}` }
                });
                alert('Produk berhasil diubah!');
            } else {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/products/`, formData, {
                    headers: { 'Authorization': `Bearer ${user.access}` }
                });
                alert('Produk berhasil ditambahkan!');
            }
            fetchDashboardData();
            setActiveTab('list');
            setDescription('');
            setUnit('pcs');
            setThumbnailFile(null);
            setThumbnailPreview(null);
            setGalleryFiles([]);
            setGalleryPreviews([]);
            setIsShippingCostActive(false);
            setShippingCostType('flat');
            setShippingCost(0);
            setIsOperationalHoursActive(false);
            setOperationalHours('');
            setIsPreorder(false);
            setPreorderType('days');
            setPreorderDays([]);
            setPreorderDaysMin('');
            setPreorderDaysMax('');
            setPreorderDuration('');
            setIsDeliveryScheduleActive(false);
            setDeliveryScheduleType('range');
            setDeliveryRangeMin('');
            setDeliveryRangeMax('');
            setDeliveryDays([]);
            setDeliveryDate('');
            setDeliveryNote('');
            setOutOfPoShippingActive(false);
            setOutOfPoShippingType('flat');
            setOutOfPoShippingCost(0);
            setAllowDeliveryTimingChoice(false);
        } catch (error) {
            console.error('Error saving product detail:', error.response?.data || error);
            const detailMsg = error.response?.data ? JSON.stringify(error.response.data) : 'Gagal menyimpan produk';
            alert(`Gagal menyimpan produk: ${detailMsg}`);
        } finally {
            setSavingProduct(false);
        }
    };


    const handleSaveVoucher = async (e) => {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem('user'));
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/products/vouchers/`, {
                code: e.target.code.value,
                nominal: parseCurrency(e.target.nominal.value),
                quantity: e.target.quantity.value,
                is_active: true
            }, { headers: { Authorization: `Bearer ${user.access}` } });
            alert('Voucher berhasil ditambahkan');
            e.target.reset();
            fetchDashboardData();
        } catch(error) {
            alert('Gagal membuat voucher. Pastikan kode unik.');
        }
    };

    const handleDeleteVoucher = async (id) => {
        const user = JSON.parse(localStorage.getItem('user'));
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/products/vouchers/${id}/`, {
                headers: { Authorization: `Bearer ${user.access}` }
            });
            fetchDashboardData();
        } catch(error) {
            alert('Gagal menghapus voucher');
        }
    };

    const handleDeleteProduct = async (id) => {
        if (!window.confirm('Apakah Anda yakin ingin menghapus produk ini?')) return;
        
        const user = JSON.parse(localStorage.getItem('user'));
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/products/${id}/?manage=true`, {
                headers: { Authorization: `Bearer ${user.access}` }
            });
            alert('Produk berhasil dihapus');
            fetchDashboardData();
        } catch (error) {
            console.error(error);
            alert('Gagal menghapus produk');
        }
    };

    const renderList = () => {
        const user = JSON.parse(localStorage.getItem('user')) || {};
        const sellerStoreSlug = sellerProfile?.shop_name || sellerProfile?.username || user?.username || 'toko';
        const sellerStoreUrl = `https://barakah.cloud/store/${sellerStoreSlug}`;

        const handleCopyStoreLink = () => {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(sellerStoreUrl).then(() => {
                    setStoreUrlCopied(true);
                    setTimeout(() => setStoreUrlCopied(false), 2500);
                });
            }
        };

        const lowStockCount = products.filter(p => {
            const s = Number(p.total_stock ?? p.stock ?? 0);
            return s > 0 && s <= 5;
        }).length;

        const outOfStockCount = products.filter(p => {
            const s = Number(p.total_stock ?? p.stock ?? 0);
            return s <= 0;
        }).length;

        const totalSoldAll = products.reduce((acc, p) => acc + (Number(p.sold_count) || 0), 0);

        // Filter products based on search and status
        const filteredProducts = products.filter(p => {
            if (productSearch.trim()) {
                const q = productSearch.toLowerCase().trim();
                const matchTitle = (p.title || '').toLowerCase().includes(q);
                const matchCat = (p.category || '').toLowerCase().includes(q);
                if (!matchTitle && !matchCat) return false;
            }

            const stock = Number(p.total_stock ?? p.stock ?? 0);
            if (statusFilter === 'low_stock') {
                return stock > 0 && stock <= 5;
            }
            if (statusFilter === 'out_of_stock') {
                return stock <= 0;
            }
            if (statusFilter === 'preorder') {
                return Boolean(p.is_preorder);
            }
            if (statusFilter === 'promo') {
                return Boolean(p.promo_discount_percentage > 0 || p.discounted_price);
            }
            return true;
        });

        return (
            <div className="space-y-6 animate-fade-in">

                {/* ACTION BAR & CONTROLS */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                    <div>
                        <h2 className="text-xl font-black text-gray-800 tracking-tight flex items-center gap-2">
                            <span>{t('seller.my_products', 'Produk (Store) Saya')}</span>
                            <span className="text-xs font-bold text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full">
                                {products.length}
                            </span>
                        </h2>
                    </div>

                    <div className="flex flex-wrap sm:flex-nowrap gap-2 w-full sm:w-auto">
                        <Link to="/dashboard/sinergy/seller/orders" className="relative flex-1 sm:flex-initial bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200 px-3.5 py-2.5 rounded-xl text-xs sm:text-sm font-bold flex items-center justify-center gap-1.5 sm:gap-2 transition-all whitespace-nowrap active:scale-95 shadow-2xs">
                            <span className="material-icons text-sm">shopping_basket</span> 
                            <span>{t('seller.incoming_orders', 'Pesanan Masuk')}</span>
                            {pendingOrdersCount > 0 && (
                                <span className="bg-red-500 text-white text-[10px] font-black px-1.5 py-0.2 rounded-full animate-pulse shadow">
                                    {pendingOrdersCount}
                                </span>
                            )}
                        </Link>
                        <button onClick={() => setActiveTab('voucher')} className="flex-1 sm:flex-initial bg-orange-50 hover:bg-orange-100 text-orange-700 border border-orange-200 px-3.5 py-2.5 rounded-xl text-xs sm:text-sm font-bold flex items-center justify-center gap-1.5 sm:gap-2 transition-all whitespace-nowrap active:scale-95 shadow-2xs">
                            <span className="material-icons text-sm">local_activity</span> 
                            <span>{t('seller.create_voucher', 'Buat Voucher')}</span>
                        </button>
                        <button 
                            type="button"
                            onClick={() => setIsQuickStockModalOpen(true)} 
                            className="flex-1 sm:flex-initial bg-emerald-50 hover:bg-emerald-100 text-emerald-800 border border-emerald-200/90 px-3.5 py-2.5 rounded-xl text-xs sm:text-sm font-bold flex items-center justify-center gap-1.5 sm:gap-2 transition-all whitespace-nowrap active:scale-95 shadow-2xs"
                            title="Edit stok cepat banyak produk sekaligus dalam bentuk list"
                        >
                            <span className="material-icons text-sm text-emerald-600">inventory_2</span> 
                            <span>{t('seller.quick_stock_edit', 'Edit Stok Cepat')}</span>
                            <span className="bg-emerald-600 text-white text-[10px] font-black px-1.5 py-0.2 rounded-full">List</span>
                        </button>
                        <button onClick={() => { 
                            setActiveTab('add'); 
                            setEditingProduct(null); 
                            setDescription('');
                            setUnit('pcs');
                            setVariants([{name: '', additional_price: 0, stock: 0}]); 
                            setManualPrice(0);
                            setManualPurchasePrice(0);
                            setManualStock(0);
                            setIsCodAvailable(false);
                            setIsShippingCostActive(false);
                            setShippingCostType('flat');
                            setShippingCost(0);
                            setThumbnailFile(null);
                            setThumbnailPreview(null);
                            setGalleryFiles([]);
                            setGalleryPreviews([]);
                            setIsOperationalHoursActive(false);
                            setOperationalHours('');
                            setIsPreorder(false);
                            setPreorderType('days');
                            setPreorderDays([]);
                            setPreorderDaysMin('');
                            setPreorderDaysMax('');
                            setPreorderDuration('');
                            setIsDeliveryScheduleActive(false);
                            setDeliveryScheduleType('range');
                            setDeliveryRangeMin('');
                            setDeliveryRangeMax('');
                            setDeliveryDays([]);
                            setDeliveryDate('');
                            setDeliveryNote('');
                            setOutOfPoShippingActive(false);
                            setOutOfPoShippingType('flat');
                            setOutOfPoShippingCost(0);
                            setAllowDeliveryTimingChoice(false);
                            setUseStoreOperationalSettings(true);
                            resetBankStates();
                        }} className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold flex items-center justify-center gap-1.5 sm:gap-2 shadow-sm transition-all shadow-emerald-200 whitespace-nowrap active:scale-95">
                            <span className="material-icons text-sm">add</span> 
                            <span>{t('seller.add_product', 'Tambah Produk Baru')}</span>
                        </button>
                    </div>
                </div>

                {/* OFFICIAL STORE BANNER & QUICK CONTROLS */}
                <div className="p-4 sm:p-5 bg-gradient-to-r from-emerald-800 via-teal-800 to-emerald-900 rounded-3xl text-white shadow-lg border border-emerald-600/30">
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <div className="min-w-0">
                            <div className="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider bg-white/20 px-3 py-1 rounded-full mb-1.5 backdrop-blur-sm">
                                <span className="material-icons text-xs">storefront</span>
                                <span>{t('seller.official_store_url', 'Alamat Resmi Toko Anda')}</span>
                            </div>
                            <p className="text-xs sm:text-base font-mono font-bold truncate text-emerald-100 flex items-center gap-1.5">
                                <span>{sellerStoreUrl}</span>
                            </p>
                            <p className="text-[11px] text-emerald-200/80 mt-1">
                                {i18n.language === 'en' 
                                    ? 'Share this official store link with buyers to view your complete personal storefront.' 
                                    : 'Bagikan tautan resmi toko ini kepada pembeli untuk melihat etalase terpadu toko Anda.'}
                            </p>
                        </div>

                        <div className="flex items-center gap-2 shrink-0 flex-wrap">
                            <button
                                type="button"
                                onClick={handleCopyStoreLink}
                                className={`px-4 py-2.5 rounded-xl text-xs font-bold transition flex items-center gap-1.5 backdrop-blur-sm ${
                                    storeUrlCopied 
                                        ? 'bg-emerald-400 text-emerald-950 font-black' 
                                        : 'bg-white/20 hover:bg-white/30 text-white'
                                }`}
                                title={t('seller.copy_store_link', 'Salin Link')}
                            >
                                <span className="material-icons text-sm">{storeUrlCopied ? 'check' : 'content_copy'}</span>
                                <span>{storeUrlCopied ? t('common.copied', 'Tersalin!') : t('seller.copy_store_link', 'Salin Link')}</span>
                            </button>

                            <a
                                href={sellerStoreUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-4 py-2.5 bg-white text-emerald-900 hover:bg-emerald-50 rounded-xl text-xs font-black shadow-md transition flex items-center gap-1.5 active:scale-95"
                            >
                                <span>{t('seller.view_my_store', 'Buka Toko')}</span>
                                <span className="material-icons text-sm">open_in_new</span>
                            </a>

                            <Link
                                to="/dashboard/shop-settings"
                                className="px-3.5 py-2.5 bg-white/15 hover:bg-white/25 text-white rounded-xl text-xs font-bold transition flex items-center gap-1.5"
                                title={t('seller.settings_store', 'Pengaturan Toko')}
                            >
                                <span className="material-icons text-sm">settings</span>
                                <span className="hidden sm:inline">{t('seller.settings_store', 'Pengaturan Toko')}</span>
                            </Link>
                        </div>
                    </div>

                    {/* Quick Store KPI Badges */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 mt-4 pt-4 border-t border-white/15">
                        <div className="bg-black/15 rounded-2xl p-2.5 text-center">
                            <span className="text-[10px] uppercase font-bold text-emerald-200 block">{t('seller.total_stock', 'Total Produk')}</span>
                            <span className="text-lg font-black text-white">{products.length}</span>
                        </div>
                        <div className="bg-black/15 rounded-2xl p-2.5 text-center">
                            <span className="text-[10px] uppercase font-bold text-emerald-200 block">{t('seller.sold_count', 'Total Terjual')}</span>
                            <span className="text-lg font-black text-emerald-300">{totalSoldAll}</span>
                        </div>
                        <div className="bg-black/15 rounded-2xl p-2.5 text-center">
                            <span className="text-[10px] uppercase font-bold text-emerald-200 block">{t('seller.filter_low_stock', 'Stok Rendah (< 5)')}</span>
                            <span className={`text-lg font-black ${lowStockCount > 0 ? 'text-amber-300' : 'text-white'}`}>{lowStockCount}</span>
                        </div>
                        <div className="bg-black/15 rounded-2xl p-2.5 text-center">
                            <span className="text-[10px] uppercase font-bold text-emerald-200 block">{t('seller.incoming_orders', 'Pesanan Masuk')}</span>
                            <span className={`text-lg font-black ${pendingOrdersCount > 0 ? 'text-rose-300 animate-pulse' : 'text-white'}`}>{pendingOrdersCount}</span>
                        </div>
                    </div>
                </div>

                {/* SEARCH & FILTER CONTROLS */}
                <div className="bg-white p-3.5 sm:p-4 rounded-2xl border border-gray-100 shadow-2xs flex flex-col md:flex-row gap-3 items-stretch md:items-center justify-between">
                    {/* Search inside seller products */}
                    <div className="relative flex-1">
                        <span className="material-icons absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-lg">search</span>
                        <input
                            type="text"
                            placeholder={t('seller.search_products_placeholder', 'Cari produk saya...')}
                            value={productSearch}
                            onChange={(e) => setProductSearch(e.target.value)}
                            className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-xs sm:text-sm focus:ring-2 focus:ring-emerald-500 focus:bg-white outline-none transition"
                        />
                        {productSearch && (
                            <button
                                type="button"
                                onClick={() => setProductSearch('')}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            >
                                <span className="material-icons text-sm">close</span>
                            </button>
                        )}
                    </div>

                    {/* Filter Status Chips */}
                    <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-none">
                        <button
                            type="button"
                            onClick={() => setStatusFilter('all')}
                            className={`px-3 py-1.5 rounded-xl text-xs font-bold whitespace-nowrap transition ${
                                statusFilter === 'all'
                                    ? 'bg-emerald-600 text-white shadow-xs'
                                    : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                            }`}
                        >
                            {t('seller.filter_all', 'Semua')} ({products.length})
                        </button>
                        <button
                            type="button"
                            onClick={() => setStatusFilter('low_stock')}
                            className={`px-3 py-1.5 rounded-xl text-xs font-bold whitespace-nowrap transition ${
                                statusFilter === 'low_stock'
                                    ? 'bg-amber-600 text-white shadow-xs'
                                    : 'bg-amber-50 hover:bg-amber-100 text-amber-700 border border-amber-200'
                            }`}
                        >
                            {t('seller.filter_low_stock', 'Stok Rendah')} ({lowStockCount})
                        </button>
                        <button
                            type="button"
                            onClick={() => setStatusFilter('out_of_stock')}
                            className={`px-3 py-1.5 rounded-xl text-xs font-bold whitespace-nowrap transition ${
                                statusFilter === 'out_of_stock'
                                    ? 'bg-rose-600 text-white shadow-xs'
                                    : 'bg-rose-50 hover:bg-rose-100 text-rose-700 border border-rose-200'
                            }`}
                        >
                            {t('seller.filter_out_of_stock', 'Stok Habis')} ({outOfStockCount})
                        </button>
                        <button
                            type="button"
                            onClick={() => setStatusFilter('preorder')}
                            className={`px-3 py-1.5 rounded-xl text-xs font-bold whitespace-nowrap transition ${
                                statusFilter === 'preorder'
                                    ? 'bg-blue-600 text-white shadow-xs'
                                    : 'bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200'
                            }`}
                        >
                            {t('seller.filter_preorder', 'Pre-Order')}
                        </button>
                        <button
                            type="button"
                            onClick={() => setStatusFilter('promo')}
                            className={`px-3 py-1.5 rounded-xl text-xs font-bold whitespace-nowrap transition ${
                                statusFilter === 'promo'
                                    ? 'bg-purple-600 text-white shadow-xs'
                                    : 'bg-purple-50 hover:bg-purple-100 text-purple-700 border border-purple-200'
                            }`}
                        >
                            {t('seller.filter_promo', 'Promo')}
                        </button>
                    </div>
                </div>
                
                {loading ? (
                    <div className="flex flex-col items-center justify-center p-12">
                        <div className="animate-spin rounded-full h-10 w-10 border-3 border-emerald-600 border-t-transparent shadow-md"></div>
                        <p className="mt-3 text-xs font-semibold text-gray-500 animate-pulse">{t('common.loading', 'Memuat daftar produk...')}</p>
                    </div>
                ) : filteredProducts.length === 0 ? (
                    <div className="text-center py-16 bg-white rounded-3xl border border-dashed border-gray-200 p-8 shadow-2xs">
                        <div className="w-16 h-16 bg-gray-100 text-gray-400 rounded-2xl flex items-center justify-center mx-auto mb-3">
                            <span className="material-icons text-3xl">inventory_2</span>
                        </div>
                        <h3 className="text-base font-bold text-gray-800 mb-1">
                            {products.length === 0 
                                ? t('seller.no_products_yet', 'Belum ada produk yang ditambahkan.') 
                                : t('seller.no_products_matching', 'Tidak ada produk yang cocok dengan pencarian atau filter status ini.')}
                        </h3>
                        {products.length === 0 ? (
                            <button
                                type="button"
                                onClick={() => setActiveTab('add')}
                                className="mt-4 px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-bold transition shadow-md shadow-emerald-200"
                            >
                                {t('seller.add_first_product', 'Tambah Produk Pertama Anda')}
                            </button>
                        ) : (
                            <button
                                type="button"
                                onClick={() => { setProductSearch(''); setStatusFilter('all'); }}
                                className="mt-4 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl text-xs font-bold transition"
                            >
                                {t('common.reset', 'Reset Filter')}
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                        {filteredProducts.map(p => {
                            const stock = Number(p.total_stock ?? p.stock ?? 0);
                            const isOutOfStock = stock <= 0;
                            const isLowStock = stock > 0 && stock <= 5;

                            return (
                                <div key={p.id} className="bg-white rounded-3xl p-4 shadow-sm border border-gray-100 flex flex-col justify-between hover:shadow-lg hover:border-emerald-200 transition-all duration-200 group">
                                    <div>
                                        {/* Product Thumbnail */}
                                        <div className="h-44 bg-gray-100 rounded-2xl overflow-hidden mb-3 relative">
                                            <img 
                                                src={getMediaUrl(p.thumbnail || p.thumbnail_url)} 
                                                alt={p.title} 
                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" 
                                                onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder-image.jpg'; }} 
                                            />

                                            {/* Badges Over Image */}
                                            <div className="absolute top-2.5 left-2.5 flex flex-col gap-1 z-10">
                                                {p.is_preorder && (
                                                    <span className="bg-amber-500 text-white text-[9px] font-black px-2 py-0.5 rounded-md shadow-sm uppercase tracking-wide">
                                                        PO
                                                    </span>
                                                )}
                                                {p.promo_discount_percentage > 0 && (
                                                    <span className="bg-rose-600 text-white text-[9px] font-black px-2 py-0.5 rounded-md shadow-sm">
                                                        HEMAT {p.promo_discount_percentage}%
                                                    </span>
                                                )}
                                            </div>

                                            {p.category && (
                                                <span className="absolute top-2.5 right-2.5 bg-black/60 backdrop-blur-sm text-white text-[10px] px-2.5 py-0.5 rounded-full font-bold">
                                                    {p.category}
                                                </span>
                                            )}

                                            {isOutOfStock && (
                                                <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-[1px] flex items-center justify-center">
                                                    <span className="bg-rose-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                                                        {t('store.out_of_stock', 'Stok Habis')}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Title & Price */}
                                        <h3 className="font-bold text-gray-800 text-base line-clamp-1 group-hover:text-emerald-700 transition">
                                            {p.title}
                                        </h3>
                                        
                                        <div className="flex items-baseline justify-between gap-2 mt-1">
                                            <p className="text-emerald-700 font-black text-base">
                                                Rp {formatCurrency(p.price)}
                                            </p>
                                            {p.purchase_price > 0 && (
                                                <span className="text-[11px] text-gray-400 font-medium">
                                                    Beli: Rp {formatCurrency(p.purchase_price)}
                                                </span>
                                            )}
                                        </div>

                                        {/* Stock & Sold Row */}
                                        <div className="flex justify-between items-center text-xs mt-2.5 pt-2 border-t border-gray-100">
                                            <div 
                                                onClick={() => setIsQuickStockModalOpen(true)}
                                                className={`px-2 py-0.5 rounded-md text-[11px] font-bold cursor-pointer hover:opacity-80 transition flex items-center gap-1 ${
                                                    isOutOfStock 
                                                        ? 'bg-rose-50 text-rose-700 border border-rose-200' 
                                                        : isLowStock 
                                                        ? 'bg-amber-50 text-amber-700 border border-amber-200' 
                                                        : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                                                }`}
                                                title="Klik untuk membuka Edit Stok Cepat"
                                            >
                                                <span>{t('store.stock', 'Stok')}: {stock} {p.unit || 'pcs'}</span>
                                                <span className="material-icons text-[12px] text-gray-400">edit</span>
                                            </div>
                                            
                                            <span 
                                                className="font-bold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-md border border-emerald-100 text-[11px]"
                                                title={`${p.store_sold_count || 0} via Toko, ${p.charity_sold_count || 0} via Charity/Waqaf`}
                                            >
                                                {t('seller.sold_count', 'Terjual')}: {p.sold_count || 0}
                                            </span>
                                        </div>

                                        <p className="text-xs text-gray-500 line-clamp-2 mt-2 leading-relaxed">
                                            {(p.description || '').replace(/<[^>]*>/g, '')}
                                        </p>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="flex items-center gap-1.5 mt-4 pt-3 border-t border-gray-100">
                                        <Link
                                            to={`/produk/${p.slug || p.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="p-2 text-xs font-bold text-slate-600 bg-slate-100 rounded-xl hover:bg-slate-200 border border-slate-200 transition flex items-center justify-center"
                                            title={t('seller.btn_view_product', 'Lihat Produk di Etalase')}
                                        >
                                            <span className="material-icons text-sm">visibility</span>
                                        </Link>

                                        <button onClick={() => {
                                            setEditingProduct(p);
                                            setDescription(p.description || '');
                                            setUnit(p.unit || 'pcs');
                                            if (p.variations && p.variations.length > 0) {
                                                setVariants(p.variations.map(v => ({ ...v, additional_price: parseCurrency(v.additional_price) || 0 })));
                                            } else {
                                                setVariants([{name: '', additional_price: 0, stock: 0}]);
                                            }
                                            setSelectedCouriers(p.supported_couriers ? p.supported_couriers.split(',') : ['jne', 'pos', 'tiki', 'jnt']);
                                            setIsCodAvailable(p.is_cod_available || false);
                                            setIsShippingCostActive(p.is_shipping_cost_active || false);
                                            setShippingCostType(p.shipping_cost_type || 'flat');
                                            setShippingCost(parseCurrency(p.shipping_cost) || 0);
                                            setManualStock(p.stock || 0);
                                            setManualPrice(parseCurrency(p.price) || 0);
                                            setManualPurchasePrice(parseCurrency(p.purchase_price) || 0);
                                            setThumbnailFile(null);
                                            setThumbnailPreview(p.thumbnail || p.thumbnail_url);
                                            setGalleryFiles([]);
                                            setGalleryPreviews(p.images ? p.images.map(img => img.image) : []);
                                            setIsOperationalHoursActive(p.is_operational_hours_active || false);
                                            setOperationalHours(p.operational_hours || '');
                                            setIsPreorder(p.is_preorder || false);
                                            setPreorderType(p.preorder_type || (p.preorder_days ? 'days' : (p.preorder_days_min ? 'range' : 'days')));
                                            setPreorderDays(p.preorder_days ? p.preorder_days.split(',').map(d => d.trim()).filter(Boolean) : []);
                                            setPreorderDaysMin(p.preorder_days_min !== null && p.preorder_days_min !== undefined ? p.preorder_days_min : '');
                                            setPreorderDaysMax(p.preorder_days_max !== null && p.preorder_days_max !== undefined ? p.preorder_days_max : '');
                                            setPreorderDuration(p.preorder_duration || '');
                                            setIsDeliveryScheduleActive(p.is_delivery_schedule_active || false);
                                            setDeliveryScheduleType(p.delivery_schedule_type || 'range');
                                            setDeliveryRangeMin(p.delivery_range_min !== null && p.delivery_range_min !== undefined ? p.delivery_range_min : '');
                                            setDeliveryRangeMax(p.delivery_range_max !== null && p.delivery_range_max !== undefined ? p.delivery_range_max : '');
                                            setDeliveryDays(p.delivery_days ? p.delivery_days.split(',').map(d => d.trim()).filter(Boolean) : []);
                                            setDeliveryDate(p.delivery_date || '');
                                            setDeliveryNote(p.delivery_note || '');
                                            setOutOfPoShippingActive(p.out_of_po_shipping_active || false);
                                            setOutOfPoShippingType(p.out_of_po_shipping_type || 'flat');
                                            setOutOfPoShippingCost(parseCurrency(p.out_of_po_shipping_cost) || 0);
                                            setAllowDeliveryTimingChoice(Boolean(p.allow_delivery_timing_choice));
                                            setActiveTab('edit');
                                        }} className="flex-1 py-2 text-xs font-bold text-emerald-700 bg-emerald-50 rounded-xl hover:bg-emerald-100 border border-emerald-100 transition flex items-center justify-center gap-1">
                                            <span className="material-icons text-xs">edit</span>
                                            <span>{t('seller.btn_edit', 'Edit')}</span>
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSelectedPromoProduct(p);
                                                setIsPromoModalOpen(true);
                                            }}
                                            className="flex-1 py-2 text-xs font-bold text-purple-700 bg-purple-50 rounded-xl hover:bg-purple-100 border border-purple-100 transition flex items-center justify-center gap-1"
                                            title={t('seller.btn_promo', 'Atur Promo & Diskon')}
                                        >
                                            <span className="material-icons text-xs">campaign</span>
                                            <span>{t('seller.btn_promo', 'Promo')}</span>
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() => openTransferModal(p)}
                                            className="w-8 py-2 text-xs font-bold text-amber-600 bg-amber-50 rounded-xl hover:bg-amber-100 border border-amber-100 transition flex items-center justify-center"
                                            title={t('seller.btn_transfer', 'Pindahkan Kepemilikan Produk ke Akun Lain')}
                                        >
                                            <span className="material-icons text-sm">swap_horiz</span>
                                        </button>

                                        <button 
                                            onClick={() => handleDeleteProduct(p.id)}
                                            className="w-8 py-2 text-xs font-bold text-red-600 bg-red-50 rounded-xl hover:bg-red-100 border border-red-100 transition flex items-center justify-center"
                                            title={t('seller.btn_delete', 'Hapus Produk')}
                                        >
                                            <span className="material-icons text-sm">delete</span>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    const renderVouchers = () => (
        <div className="bg-white rounded-3xl p-6 shadow-xl border border-gray-100 animate-slide-up">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
                <button type="button" onClick={() => setActiveTab('list')} className="w-8 h-8 flex items-center justify-center bg-gray-50 hover:bg-gray-100 rounded-full text-gray-500 transition"><span className="material-icons">arrow_back</span></button>
                <h2 className="text-xl font-bold text-gray-800">Manajemen Kupon / Voucher</h2>
            </div>

            <form className="bg-orange-50 p-4 rounded-2xl mb-8 border border-orange-100 space-y-4" onSubmit={handleSaveVoucher}>
                <h3 className="font-bold text-orange-800 text-sm">Buat Voucher Baru</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-[11px] font-bold text-gray-600 mb-1">KODE (Huruf/Angka)</label>
                        <input type="text" name="code" required placeholder="Cth: BAE2025" className="w-full px-3 py-2 text-sm border-none rounded-xl outline-none focus:ring-2 focus:ring-orange-400" />
                    </div>
                    <div>
                        <label className="block text-[11px] font-bold text-gray-600 mb-1">Nominal Diskon (Rp)</label>
                        <CurrencyInput name="nominal" required placeholder="10000" className="!px-3 !py-2 !rounded-xl" />
                    </div>
                    <div>
                        <label className="block text-[11px] font-bold text-gray-600 mb-1">Batas Kuota Pemakaian</label>
                        <input type="number" name="quantity" required placeholder="50" className="w-full px-3 py-2 text-sm border-none rounded-xl outline-none focus:ring-2 focus:ring-orange-400" />
                    </div>
                </div>
                <button type="submit" className="bg-orange-600 text-white font-bold text-xs px-6 py-2 rounded-full hover:bg-orange-700 transition">Buat Voucher</button>
            </form>

            <div>
                <h3 className="font-bold text-gray-800 text-sm mb-4">Voucher Aktif Anda</h3>
                {vouchers.length === 0 ? (
                    <p className="text-xs text-gray-400">Belum ada voucher yang dibuat.</p>
                ) : (
                    <div className="space-y-3">
                        {vouchers.map(v => (
                            <div key={v.id} className="flex justify-between items-center bg-gray-50 p-4 rounded-xl border border-gray-100">
                                <div>
                                    <h4 className="font-bold text-emerald-700 text-lg uppercase">{v.code}</h4>
                                    <p className="text-xs text-gray-500">Potongan Rp {formatCurrency(v.nominal)} • Sisa Kuota: {v.quantity}</p>
                                </div>
                                <button onClick={() => handleDeleteVoucher(v.id)} className="text-red-500 bg-red-50 p-2 rounded-lg hover:bg-red-100">
                                    <span className="material-icons text-[18px]">delete</span>
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );

    const renderForm = () => (
        <div className="bg-white rounded-3xl p-6 shadow-xl border border-gray-100 animate-slide-up">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
                <button type="button" onClick={() => setActiveTab('list')} className="w-8 h-8 flex items-center justify-center bg-gray-50 hover:bg-gray-100 rounded-full text-gray-500 transition"><span className="material-icons">arrow_back</span></button>
                <h2 className="text-xl font-bold text-gray-800">{activeTab === 'edit' ? 'Edit Produk E-commerce' : 'Tambah Produk E-commerce Baru'}</h2>
            </div>
            
            <form className="space-y-6" onSubmit={handleSaveProduct}>
                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Nama Produk</label>
                    <input type="text" name="title" defaultValue={editingProduct?.title || ''} placeholder="Contoh: Buku Fiqih Muamalah Kontemporer / Madu Asli 500ml" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition" />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Harga Beli Dasar (Rp)</label>
                        <CurrencyInput 
                            name="purchase_price" 
                            value={manualPurchasePrice} 
                            onChange={(e) => setManualPurchasePrice(e.target.value)}
                            placeholder="0" 
                            className="!px-4 !py-3 !bg-gray-50 !border-gray-200 !rounded-xl" 
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Harga Jual (Rp) {variants.length > 0 && variants[0].name && <span className="text-[10px] text-emerald-600">(Auto dari Variasi)</span>}</label>
                        <CurrencyInput 
                            name="price" 
                            value={variants.length > 0 && variants[0].name ? Math.min(...variants.map(v => v.additional_price || 0)) : manualPrice} 
                            onChange={(e) => setManualPrice(e.target.value)}
                            required 
                            placeholder="0" 
                            className={`!px-4 !py-3 !bg-gray-50 !border-gray-200 !rounded-xl ${variants.length > 0 && variants[0].name ? 'opacity-70' : ''}`}
                            readOnly={variants.length > 0 && variants[0].name}
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Stok Gudang {variants.length > 0 && variants[0].name && <span className="text-[10px] text-emerald-600">(Auto)</span>}</label>
                        <input 
                            type="number" 
                            name="stock" 
                            value={variants.length > 0 && variants[0].name ? variants.reduce((sum, v) => sum + (parseInt(v.stock) || 0), 0) : manualStock} 
                            onChange={(e) => setManualStock(e.target.value)}
                            required 
                            placeholder="0" 
                            className={`w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition ${variants.length > 0 && variants[0].name ? 'opacity-70' : ''}`} 
                            readOnly={variants.length > 0 && variants[0].name}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Satuan Produk (Unit)</label>
                        <select 
                            name="unit"
                            value={unit}
                            onChange={(e) => setUnit(e.target.value)}
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition font-medium text-gray-800"
                        >
                            <option value="pcs">pcs / buah (Default)</option>
                            <option value="buku">buku / eksemplar</option>
                            <option value="eksemplar">eksemplar</option>
                            <option value="lembar">lembar</option>
                            <option value="jilid">jilid</option>
                            <option value="kg">kg (Kilogram)</option>
                            <option value="gram">gram (g)</option>
                            <option value="50 gram">50 gram</option>
                            <option value="100 gram">100 gram</option>
                            <option value="200 gram">200 gram</option>
                            <option value="250 gram">250 gram</option>
                            <option value="500 gram">500 gram</option>
                            <option value="ons">ons</option>
                            <option value="ikat">ikat</option>
                            <option value="liter">liter (L)</option>
                            <option value="ml">mililiter (ml)</option>
                            <option value="pack">pack / bungkus</option>
                            <option value="box">box / kotak</option>
                            <option value="dus">dus / karton</option>
                            <option value="botol">botol</option>
                            <option value="sachet">sachet</option>
                            <option value="kaleng">kaleng</option>
                            <option value="pasang">pasang</option>
                            <option value="set">set</option>
                            <option value="unit">unit</option>
                            <option value="porsi">porsi</option>
                            <option value="lusin">lusin (12 pcs)</option>
                            <option value="kodi">kodi (20 pcs)</option>
                            <option value="meter">meter (m)</option>
                            <option value="paket">paket</option>
                        </select>
                    </div>
                    <div>
                         <label className="block text-sm font-semibold text-gray-700 mb-1">Berat (gram)</label>
                        <input type="number" name="weight" defaultValue={editingProduct?.weight || ''} required placeholder="1000" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition" />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Kategori</label>
                        <input type="text" name="category" list="categories" required placeholder="Pilih / Ketik Kategori" defaultValue={editingProduct?.category || ''} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition" />
                        <datalist id="categories">
                            <option value="Buku Islami" />
                            <option value="Pakaian" />
                            <option value="Herbal" />
                            <option value="Sembako" />
                            <option value="Elektronik" />
                            <option value="Aksesoris" />
                            <option value="Kuliner / Makanan" />
                        </datalist>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center justify-between">
                        <span>Deskripsi Lengkap Produk *</span>
                        <span className="text-[11px] text-emerald-600 font-medium">Mendukung Rich Text (Tebal, Poin-poin, Heading, dsb)</span>
                    </label>
                    <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm bg-white">
                        <CKEditorComponent 
                            content={description}
                            onChange={(data) => setDescription(data)}
                            placeholder="Tuliskan deskripsi lengkap, keunggulan, spesifikasi buku/produk, atau detail lainnya..."
                        />
                    </div>
                </div>


                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Informasi Pengambilan / Teknis (Opsional)</label>
                    <textarea 
                        name="purchase_instructions" 
                        defaultValue={editingProduct?.purchase_instructions || ''} 
                        placeholder="Contoh: Pengambilan dilakukan di lokasi toko/kandang, atau teknis khusus..." 
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition h-24"
                    ></textarea>
                </div>

                <div className="bg-emerald-50/70 p-5 rounded-2xl border border-emerald-100 space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl bg-emerald-600 text-white flex items-center justify-center font-bold shadow-md shadow-emerald-200 shrink-0">
                                <span className="material-icons">local_shipping</span>
                            </div>
                            <div>
                                <h4 className="text-sm font-bold text-emerald-900">Sistem Pengiriman & Ongkos Kirim</h4>
                                <p className="text-xs text-emerald-700">Atur ongkir flat toko dan ketersediaan bayar di tempat (COD).</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-xl shadow-sm border border-emerald-200 self-start sm:self-auto">
                            <span className="text-[11px] font-bold text-gray-700 uppercase tracking-tight">Aktifkan COD</span>
                            <button
                                type="button"
                                onClick={() => setIsCodAvailable(!isCodAvailable)}
                                className={`w-10 h-5 rounded-full transition-all relative ${isCodAvailable ? 'bg-emerald-500' : 'bg-gray-300'}`}
                            >
                                <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${isCodAvailable ? 'left-5.5' : 'left-0.5'}`}></div>
                            </button>
                        </div>
                    </div>

                    {/* Aktifkan Ongkir Flat Toko */}
                    <div className="pt-3 border-t border-emerald-200/60 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                        <div>
                            <div className="flex items-center gap-2">
                                <span className="text-xs font-bold text-gray-800">Aktifkan Harga Ongkir Toko</span>
                                <span className="text-[9px] bg-emerald-100 text-emerald-800 font-bold px-2 py-0.5 rounded-full">Tarif Flat Toko</span>
                            </div>
                            <p className="text-[10px] text-gray-500 mt-0.5">
                                Jika pembeli membeli lebih dari 1 produk di toko Anda, <b>ongkir disamakan (tidak berlaku kelipatan)</b>.
                            </p>
                        </div>
                        <div className="flex items-center gap-3">
                            <button
                                type="button"
                                onClick={() => setIsShippingCostActive(!isShippingCostActive)}
                                className={`w-10 h-5 rounded-full transition-all relative shrink-0 ${isShippingCostActive ? 'bg-emerald-500' : 'bg-gray-300'}`}
                            >
                                <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${isShippingCostActive ? 'left-5.5' : 'left-0.5'}`}></div>
                            </button>
                        </div>
                    </div>

                    {isShippingCostActive && (
                        <div className="pt-2 border-t border-gray-100 space-y-3">
                            <div>
                                <label className="block text-xs font-semibold text-gray-700 mb-1.5">Pilih Tipe Tarif Ongkir Toko</label>
                                <div className="grid grid-cols-2 gap-2">
                                    <button
                                        type="button"
                                        onClick={() => setShippingCostType('flat')}
                                        className={`py-2 px-2.5 rounded-xl border text-xs font-bold flex items-center justify-center gap-1.5 transition ${shippingCostType === 'flat' ? 'bg-emerald-100 border-emerald-400 text-emerald-900 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                    >
                                        <span className="material-icons text-sm">local_shipping</span>
                                        <span>Flat Ongkir</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setShippingCostType('distance')}
                                        className={`py-2 px-2.5 rounded-xl border text-xs font-bold flex items-center justify-center gap-1.5 transition ${shippingCostType === 'distance' ? 'bg-emerald-100 border-emerald-400 text-emerald-900 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                    >
                                        <span className="material-icons text-sm">straighten</span>
                                        <span>Sesuai Jarak</span>
                                    </button>
                                </div>
                            </div>

                            {shippingCostType === 'flat' ? (
                                <div>
                                    <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                                        Nominal Ongkos Kirim Flat (Rp) *
                                    </label>
                                    <div className="max-w-xs">
                                        <CurrencyInput 
                                            value={shippingCost !== undefined && shippingCost !== null ? shippingCost : ''} 
                                            onChange={(e) => setShippingCost(parseCurrency(e.target.value))} 
                                            placeholder="Contoh: 10.000" 
                                            className="!px-3 !py-2.5 !bg-white !rounded-xl !border-emerald-300 !text-emerald-700 !font-black !text-sm"
                                        />
                                    </div>
                                    <p className="text-[10px] text-gray-500 mt-1">Tarif tetap satu harga flat walau membeli banyak barang di toko Anda.</p>
                                </div>
                            ) : (
                                <div className="p-3 bg-emerald-50 rounded-xl border border-emerald-200 text-emerald-900 text-xs space-y-1">
                                    <div className="flex items-center gap-1.5 font-bold">
                                        <span className="material-icons text-emerald-600 text-sm">info</span>
                                        <span>Ongkos Kirim Dihitung Sesuai Jarak</span>
                                    </div>
                                    <p className="text-[11px] text-emerald-800 leading-relaxed">
                                        Biaya pengiriman akan dihitung sesuai jarak pengantaran. Pihak penjual, admin, atau kurir akan mengabari pembeli mengenai total ongkir setelah pesanan masuk. Keterangan ini akan otomatis ditampilkan kepada pembeli di halaman detail dan saat checkout.
                                    </p>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Foto Utama (Thumbnail)</label>
                        <div 
                            onClick={() => document.getElementById('thumbnail-input').click()}
                            className="border-2 border-dashed border-gray-200 rounded-2xl p-4 text-center hover:border-emerald-500 hover:bg-emerald-50/30 cursor-pointer transition-all relative overflow-hidden h-40 flex flex-col items-center justify-center bg-gray-50/50"
                        >
                            {thumbnailPreview ? (
                                <img src={thumbnailPreview} alt="Preview" className="absolute inset-0 w-full h-full object-cover" />
                            ) : (
                                <>
                                    <span className="material-icons text-gray-400 text-3xl mb-2">add_a_photo</span>
                                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Pilih Foto Utama</p>
                                </>
                            )}
                            <input id="thumbnail-input" type="file" accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp,image/*" className="hidden" onChange={handleThumbnailChange} />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Galeri Foto (Carousel)</label>
                        <div 
                            onClick={() => document.getElementById('gallery-input').click()}
                            className="border-2 border-dashed border-gray-200 rounded-2xl p-4 text-center hover:border-emerald-500 hover:bg-emerald-50/30 cursor-pointer transition-all h-40 flex flex-col items-center justify-center bg-gray-50/50"
                        >
                            <span className="material-icons text-gray-400 text-3xl mb-2">collections</span>
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Pilih Hingga 5 Foto (JPG, PNG, WebP)</p>
                            <input id="gallery-input" type="file" accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp,image/*" multiple className="hidden" onChange={handleGalleryChange} />
                        </div>
                        {galleryPreviews.length > 0 && (
                            <div className="flex gap-2 mt-3 overflow-x-auto pb-2">
                                {galleryPreviews.map((src, idx) => (
                                    <img key={idx} src={src} alt={`Preview ${idx}`} className="w-12 h-12 rounded-lg object-cover border border-gray-200 shadow-sm" />
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="bg-emerald-50/50 rounded-2xl p-4 border border-emerald-100">
                    <div className="flex justify-between items-center mb-3">
                        <h4 className="font-bold text-gray-800 text-sm">Varian Produk</h4>
                        <button type="button" onClick={addVariant} className="text-xs bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-bold hover:bg-emerald-200">+ Varian</button>
                    </div>
                    
                    <div className="space-y-3">
                        {variants.map((v, i) => (
                            <div key={i} className="flex gap-2">
                                <input type="text" placeholder="Nama Varian (Cth: XL / Merah)" value={v.name} onChange={(e) => updateVariant(i, 'name', e.target.value)} className="flex-[2] px-3 py-2 text-sm border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-emerald-500" />
                                <div className="flex-1 relative">
                                    <CurrencyInput 
                                        value={v.additional_price !== undefined && v.additional_price !== null && v.additional_price !== '' ? v.additional_price : ''} 
                                        onChange={(e) => updateVariant(i, 'additional_price', e.target.value)} 
                                        placeholder="Harga" 
                                        className="!px-2 !py-2 !rounded-lg !border-gray-200 !text-emerald-700" 
                                        title="Harga Total untuk varian ini" 
                                    />
                                </div>
                                <div className="w-20 relative">
                                    <input 
                                        type="number" 
                                        placeholder="Stok" 
                                        value={v.stock !== undefined && v.stock !== null ? v.stock : ''} 
                                        onChange={(e) => updateVariant(i, 'stock', e.target.value === '' ? '' : parseInt(e.target.value, 10) || 0)} 
                                        className="w-full px-2 py-2 text-sm border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-emerald-500" 
                                    />
                                </div>
                                {variants.length > 1 && (
                                    <button type="button" onClick={() => removeVariant(i)} className="w-10 flex items-center justify-center text-red-500 bg-red-50 rounded-lg hover:bg-red-100 transition"><span className="material-icons text-sm">delete</span></button>
                                )}
                            </div>
                        ))}
                    </div>
                    <p className="text-[10px] text-gray-500 mt-3 pt-2 border-t border-emerald-200/50">Harga varian adalah <b>Harga Total</b> yang akan dibayar pembeli (menggantikan harga produk utama).</p>
                </div>

                {/* Pengaturan Tambahan: Jam Operasional, Pre-Order & Pengantaran */}
                <div className="bg-white rounded-2xl p-4 sm:p-5 border border-gray-200 shadow-sm space-y-5">
                    <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
                        <span className="material-icons text-emerald-600">tune</span>
                        <div>
                            <h4 className="font-bold text-gray-800 text-sm">Pengaturan Jam Operasional, Pre-Order & Pengantaran</h4>
                            <p className="text-[11px] text-gray-400">Atur fitur tambahan ini jika berlaku pada produk Anda (tidak wajib)</p>
                        </div>
                    </div>

                    {/* Mode Selector: Ikuti Toko vs Kustomisasi Khusus */}
                    <div className="p-3.5 bg-slate-50 rounded-xl border border-slate-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                        <div>
                            <span className="text-xs font-bold text-gray-800 block">Sumber Pengaturan</span>
                            <span className="text-[11px] text-gray-500">Pilih apakah produk ini mengikuti pengaturan global toko atau dikustomisasi khusus</span>
                        </div>
                        <div className="inline-flex p-1 bg-white rounded-xl border border-gray-200 self-start sm:self-auto shrink-0 shadow-xs">
                            <button
                                type="button"
                                onClick={() => setUseStoreOperationalSettings(true)}
                                className={`px-3 py-1.5 rounded-lg text-xs font-bold transition flex items-center gap-1.5 ${useStoreOperationalSettings ? 'bg-emerald-600 text-white shadow-xs' : 'text-gray-600 hover:text-gray-900'}`}
                            >
                                <span className="material-icons text-sm">storefront</span>
                                <span>Ikuti Pengaturan Toko</span>
                            </button>
                            <button
                                type="button"
                                onClick={() => setUseStoreOperationalSettings(false)}
                                className={`px-3 py-1.5 rounded-lg text-xs font-bold transition flex items-center gap-1.5 ${!useStoreOperationalSettings ? 'bg-indigo-600 text-white shadow-xs' : 'text-gray-600 hover:text-gray-900'}`}
                            >
                                <span className="material-icons text-sm">tune</span>
                                <span>Kustomisasi Khusus</span>
                            </button>
                        </div>
                    </div>

                    {useStoreOperationalSettings ? (
                        <div className="p-4 sm:p-5 rounded-xl bg-gradient-to-br from-emerald-50 via-teal-50/40 to-white border border-emerald-200/80 space-y-3 animate-fade-in">
                            <div className="flex items-start gap-3">
                                <div className="w-9 h-9 rounded-xl bg-emerald-600 text-white flex items-center justify-center shrink-0 shadow-xs">
                                    <span className="material-icons text-lg">check_circle</span>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h5 className="text-xs sm:text-sm font-bold text-emerald-950">
                                        Mengikuti Pengaturan Jam Operasional & PO Global Toko
                                    </h5>
                                    <p className="text-[11px] text-emerald-800 leading-relaxed mt-0.5">
                                        Produk ini otomatis mewarisi jam operasional, sistem PO, jadwal pengantaran, dan tarif ongkir toko Anda. Cukup atur sekali di Pengaturan Toko dan berlaku untuk semua produk.
                                    </p>
                                </div>
                            </div>

                            {sellerProfile && (
                                <div className="p-3 bg-white/90 backdrop-blur-xs rounded-xl border border-emerald-200/70 text-xs space-y-2">
                                    <div className="flex items-center justify-between text-[11px] font-bold text-gray-700 pb-1.5 border-b border-gray-100">
                                        <span className="flex items-center gap-1 text-emerald-900">
                                            <span className="material-icons text-xs text-emerald-600">store</span>
                                            Pengaturan Aktif di Toko Anda:
                                        </span>
                                        <Link to="/dashboard/shop-settings" target="_blank" className="text-emerald-700 hover:underline flex items-center gap-0.5 text-[11px]">
                                            <span>Ubah di Pengaturan Toko</span>
                                            <span className="material-icons text-xs">open_in_new</span>
                                        </Link>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-[11px]">
                                        <div className="flex items-center gap-1.5 text-gray-700">
                                            <span className="material-icons text-sm text-emerald-600">storefront</span>
                                            <span>Jam Buka: <b>{sellerProfile.is_operational_hours_active ? (sellerProfile.operational_hours || 'Aktif') : 'Tidak Diaktifkan'}</b></span>
                                        </div>
                                        <div className="flex items-center gap-1.5 text-gray-700">
                                            <span className="material-icons text-sm text-blue-600">hourglass_top</span>
                                            <span>Sistem PO: <b>{sellerProfile.is_preorder ? (sellerProfile.preorder_duration || (sellerProfile.preorder_days ? `Hari ${sellerProfile.preorder_days}` : 'Aktif')) : 'Tidak Ada PO'}</b></span>
                                        </div>
                                        <div className="flex items-center gap-1.5 text-gray-700">
                                            <span className="material-icons text-sm text-amber-600">local_shipping</span>
                                            <span>Pengantaran: <b>{sellerProfile.is_delivery_schedule_active ? (sellerProfile.delivery_days ? `Hari ${sellerProfile.delivery_days}` : (sellerProfile.delivery_range_min ? `${sellerProfile.delivery_range_min}-${sellerProfile.delivery_range_max} Hari` : 'Aktif')) : 'Standar Toko'}</b></span>
                                        </div>
                                        <div className="flex items-center gap-1.5 text-gray-700">
                                            <span className="material-icons text-sm text-purple-600">local_atm</span>
                                            <span>Ongkir Luar Jam PO: <b>{sellerProfile.out_of_po_shipping_active ? (sellerProfile.out_of_po_shipping_type === 'distance' ? 'Sesuai Jarak' : `Rp ${formatCurrency(sellerProfile.out_of_po_shipping_cost)}`) : 'Tidak Aktif'}</b></span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="space-y-4 pt-1 animate-fade-in">
                            <div className="p-3 bg-indigo-50 border border-indigo-200 rounded-xl text-indigo-900 text-xs flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                    <span className="material-icons text-indigo-600 text-sm">tune</span>
                                    <span><b>Mode Kustomisasi Aktif:</b> Pengaturan di bawah ini khusus untuk produk ini saja dan mengabaikan pengaturan toko.</span>
                                </div>
                            </div>

                            {/* 1. Jam Operasional */}
                            <div className="bg-gradient-to-br from-gray-50 to-emerald-50/20 p-4 rounded-xl border border-gray-200/70">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-9 h-9 rounded-xl flex items-center justify-center transition-colors ${isOperationalHoursActive ? 'bg-emerald-600 text-white shadow-sm shadow-emerald-200' : 'bg-gray-200 text-gray-500'}`}>
                                            <span className="material-icons text-lg">storefront</span>
                                        </div>
                                        <div>
                                            <p className="text-xs font-bold text-gray-800">Jam Operasional Khusus</p>
                                            <p className="text-[10px] text-gray-500">Tampilkan hari & jam buka toko pada halaman detail produk ini</p>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setIsOperationalHoursActive(!isOperationalHoursActive)}
                                        className={`w-11 h-6 rounded-full transition-all relative ${isOperationalHoursActive ? 'bg-emerald-600' : 'bg-gray-300'}`}
                                    >
                                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${isOperationalHoursActive ? 'left-6' : 'left-1'}`}></div>
                                    </button>
                                </div>

                                {isOperationalHoursActive && (
                                    <div className="mt-3.5 pt-3.5 border-t border-gray-200/60 space-y-2">
                                        <label className="block text-xs font-semibold text-gray-700">Jam / Hari Buka Toko</label>
                                        <input
                                            type="text"
                                            value={operationalHours}
                                            onChange={(e) => setOperationalHours(e.target.value)}
                                            placeholder="Contoh: Senin - Sabtu, 08:00 - 17:00 WIB"
                                            className="w-full px-3.5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-medium text-gray-800 outline-none focus:ring-2 focus:ring-emerald-500 transition"
                                        />
                                        <div className="flex flex-wrap gap-1.5 pt-1">
                                            <span className="text-[10px] text-gray-400 self-center mr-1">Pilihan Cepat:</span>
                                            {['Setiap Hari (08:00 - 21:00 WIB)', 'Senin - Sabtu (08:00 - 17:00 WIB)', 'Senin - Jumat (09:00 - 17:00 WIB)'].map((preset) => (
                                                <button
                                                    key={preset}
                                                    type="button"
                                                    onClick={() => setOperationalHours(preset)}
                                                    className="text-[10px] bg-white border border-gray-200 hover:border-emerald-500 hover:text-emerald-700 px-2.5 py-1 rounded-lg text-gray-600 transition"
                                                >
                                                    {preset}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* 2. Sistem Pre-Order (PO) */}
                            <div className="bg-gradient-to-br from-gray-50 to-blue-50/20 p-4 rounded-xl border border-gray-200/70">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-9 h-9 rounded-xl flex items-center justify-center transition-colors ${isPreorder ? 'bg-blue-600 text-white shadow-sm shadow-blue-200' : 'bg-gray-200 text-gray-500'}`}>
                                            <span className="material-icons text-lg">hourglass_top</span>
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-2">
                                                <p className="text-xs font-bold text-gray-800">Sistem Pre-Order (PO) Khusus</p>
                                                {isPreorder && (
                                                    <span className="text-[9px] font-extrabold uppercase px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">Aktif</span>
                                                )}
                                            </div>
                                            <p className="text-[10px] text-gray-500">Tandai produk butuh waktu proses PO sebelum dikirimkan</p>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setIsPreorder(!isPreorder)}
                                        className={`w-11 h-6 rounded-full transition-all relative ${isPreorder ? 'bg-blue-600' : 'bg-gray-300'}`}
                                    >
                                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${isPreorder ? 'left-6' : 'left-1'}`}></div>
                                    </button>
                                </div>

                                {isPreorder && (
                                    <div className="mt-3.5 pt-3.5 border-t border-gray-200/60 space-y-3.5">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-1.5">Pilih Tipe Jadwal Pre-Order</label>
                                            <div className="grid grid-cols-2 gap-2">
                                                {[
                                                    { id: 'days', label: 'Pilih Hari Tertentu', icon: 'view_week' },
                                                    { id: 'range', label: 'Rentang Hari', icon: 'date_range' },
                                                ].map((t) => (
                                                    <button
                                                        key={t.id}
                                                        type="button"
                                                        onClick={() => setPreorderType(t.id)}
                                                        className={`py-2 px-2.5 rounded-xl border text-xs font-bold flex items-center justify-center gap-1.5 transition ${preorderType === t.id ? 'bg-blue-100 border-blue-400 text-blue-900 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                                    >
                                                        <span className="material-icons text-sm">{t.icon}</span>
                                                        <span>{t.label}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {preorderType === 'days' && (
                                            <div className="space-y-2">
                                                <label className="block text-xs font-semibold text-gray-700">Pilih Hari PO dalam Seminggu</label>
                                                <div className="flex flex-wrap gap-1.5">
                                                    {['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu'].map((day) => {
                                                        const isSelected = preorderDays.includes(day);
                                                        return (
                                                            <button
                                                                key={day}
                                                                type="button"
                                                                onClick={() => {
                                                                    if (isSelected) {
                                                                        setPreorderDays(preorderDays.filter(d => d !== day));
                                                                    } else {
                                                                        setPreorderDays([...preorderDays, day]);
                                                                    }
                                                                }}
                                                                className={`px-3 py-1.5 rounded-lg text-xs font-bold border transition ${isSelected ? 'bg-blue-600 border-blue-700 text-white shadow-sm' : 'bg-white border-gray-200 text-gray-700 hover:border-blue-300'}`}
                                                            >
                                                                {day}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                                {preorderDays.length > 0 && (
                                                    <div className="p-2.5 rounded-xl bg-blue-50/80 border border-blue-200/70 space-y-1">
                                                        <p className="text-[11px] text-blue-900 font-medium">
                                                            Dipilih: <span className="font-bold">{preorderDays.join(', ')}</span>
                                                        </p>
                                                        {(() => {
                                                            const nextInfo = getNextDateFromDays(preorderDays);
                                                            return nextInfo ? (
                                                                <p className="text-[11px] text-blue-800 font-semibold flex items-center gap-1.5">
                                                                    <span className="material-icons text-[14px] text-blue-600">event</span>
                                                                    <span>Jadwal PO Terdekat: <strong className="text-blue-950 underline">{nextInfo.display}</strong></span>
                                                                </p>
                                                            ) : null;
                                                        })()}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {preorderType === 'range' && (
                                            <div className="space-y-1.5">
                                                <label className="block text-xs font-semibold text-gray-700">Waktu / Lama PO (Rentang Hari)</label>
                                                <div className="flex items-center gap-2 sm:gap-3">
                                                    <div className="flex-1 relative">
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={preorderDaysMin}
                                                            onChange={(e) => setPreorderDaysMin(e.target.value)}
                                                            placeholder="Min (Cth: 3)"
                                                            className="w-full px-3.5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-medium text-gray-800 outline-none focus:ring-2 focus:ring-blue-500 transition"
                                                        />
                                                        <span className="absolute right-3 top-2.5 text-[11px] text-gray-400">Hari</span>
                                                    </div>
                                                    <span className="text-xs text-gray-400 font-bold">s/d</span>
                                                    <div className="flex-1 relative">
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={preorderDaysMax}
                                                            onChange={(e) => setPreorderDaysMax(e.target.value)}
                                                            placeholder="Maks (Cth: 7)"
                                                            className="w-full px-3.5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-medium text-gray-800 outline-none focus:ring-2 focus:ring-blue-500 transition"
                                                        />
                                                        <span className="absolute right-3 top-2.5 text-[11px] text-gray-400">Hari</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div>
                                            <label className="block text-[11px] text-gray-500 mb-1">Keterangan Label PO (Opsional)</label>
                                            <input
                                                type="text"
                                                value={preorderDuration}
                                                onChange={(e) => setPreorderDuration(e.target.value)}
                                                placeholder={preorderType === 'days' && preorderDays.length > 0 ? `Contoh: Setiap ${preorderDays.join(', ')}` : "Contoh: 3 - 7 Hari (Dibuat sesuai pesanan)"}
                                                className="w-full px-3.5 py-2 bg-white border border-gray-200 rounded-xl text-xs text-gray-700 outline-none focus:ring-2 focus:ring-blue-400 transition"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* 3. Jadwal & Tanggal Pengantaran */}
                            <div className="bg-gradient-to-br from-gray-50 to-amber-50/20 p-4 rounded-xl border border-gray-200/70">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-9 h-9 rounded-xl flex items-center justify-center transition-colors ${isDeliveryScheduleActive ? 'bg-amber-600 text-white shadow-sm shadow-amber-200' : 'bg-gray-200 text-gray-500'}`}>
                                            <span className="material-icons text-lg">local_shipping</span>
                                        </div>
                                        <div>
                                            <p className="text-xs font-bold text-gray-800">Jadwal & Tanggal Pengantaran Khusus</p>
                                            <p className="text-[10px] text-gray-500">Bebas pilih rentang hari pengiriman atau tentukan hari/tanggal tertentu</p>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setIsDeliveryScheduleActive(!isDeliveryScheduleActive)}
                                        className={`w-11 h-6 rounded-full transition-all relative ${isDeliveryScheduleActive ? 'bg-amber-600' : 'bg-gray-300'}`}
                                    >
                                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${isDeliveryScheduleActive ? 'left-6' : 'left-1'}`}></div>
                                    </button>
                                </div>

                                {isDeliveryScheduleActive && (
                                    <div className="mt-3.5 pt-3.5 border-t border-gray-200/60 space-y-3.5">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-1.5">Pilih Tipe Jadwal Pengantaran</label>
                                            <div className="grid grid-cols-3 gap-2">
                                                {[
                                                    { id: 'range', label: 'Rentang Hari', icon: 'date_range' },
                                                    { id: 'days', label: 'Pilih Hari Tertentu', icon: 'view_week' },
                                                    { id: 'date', label: 'Tanggal Spesifik', icon: 'event' }
                                                ].map((t) => (
                                                    <button
                                                        key={t.id}
                                                        type="button"
                                                        onClick={() => setDeliveryScheduleType(t.id)}
                                                        className={`py-2 px-2.5 rounded-xl border text-xs font-bold flex flex-col sm:flex-row items-center justify-center gap-1.5 transition ${deliveryScheduleType === t.id ? 'bg-amber-100 border-amber-400 text-amber-900 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                                    >
                                                        <span className="material-icons text-sm">{t.icon}</span>
                                                        <span>{t.label}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {deliveryScheduleType === 'range' && (
                                            <div className="space-y-1.5">
                                                <label className="block text-xs font-semibold text-gray-700">Estimasi Pengantaran (Rentang Hari)</label>
                                                <div className="flex items-center gap-2 sm:gap-3">
                                                    <div className="flex-1 relative">
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={deliveryRangeMin}
                                                            onChange={(e) => setDeliveryRangeMin(e.target.value)}
                                                            placeholder="Min (Cth: 1)"
                                                            className="w-full px-3.5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-medium text-gray-800 outline-none focus:ring-2 focus:ring-amber-500 transition"
                                                        />
                                                        <span className="absolute right-3 top-2.5 text-[11px] text-gray-400">Hari</span>
                                                    </div>
                                                    <span className="text-xs text-gray-400 font-bold">s/d</span>
                                                    <div className="flex-1 relative">
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={deliveryRangeMax}
                                                            onChange={(e) => setDeliveryRangeMax(e.target.value)}
                                                            placeholder="Maks (Cth: 3)"
                                                            className="w-full px-3.5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-medium text-gray-800 outline-none focus:ring-2 focus:ring-amber-500 transition"
                                                        />
                                                        <span className="absolute right-3 top-2.5 text-[11px] text-gray-400">Hari</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {deliveryScheduleType === 'days' && (
                                            <div className="space-y-1.5">
                                                <label className="block text-xs font-semibold text-gray-700">Pilih Hari Pengantaran dalam Seminggu</label>
                                                <div className="flex flex-wrap gap-1.5">
                                                    {['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu'].map((day) => {
                                                        const isSelected = deliveryDays.includes(day);
                                                        return (
                                                            <button
                                                                key={day}
                                                                type="button"
                                                                onClick={() => {
                                                                    if (isSelected) {
                                                                        setDeliveryDays(deliveryDays.filter(d => d !== day));
                                                                    } else {
                                                                        setDeliveryDays([...deliveryDays, day]);
                                                                    }
                                                                }}
                                                                className={`px-3 py-1.5 rounded-lg text-xs font-bold border transition ${isSelected ? 'bg-amber-500 border-amber-600 text-white shadow-sm' : 'bg-white border-gray-200 text-gray-700 hover:border-amber-300'}`}
                                                            >
                                                                {day}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                                {deliveryDays.length > 0 && (
                                                    <p className="text-[11px] text-amber-800 font-medium mt-1">
                                                        Dipilih: <span className="font-bold">{deliveryDays.join(', ')}</span>
                                                    </p>
                                                )}
                                            </div>
                                        )}

                                        {deliveryScheduleType === 'date' && (
                                            <div className="space-y-1.5">
                                                <label className="block text-xs font-semibold text-gray-700">Tanggal Pengantaran Spesifik</label>
                                                <input
                                                    type="date"
                                                    value={deliveryDate}
                                                    onChange={(e) => setDeliveryDate(e.target.value)}
                                                    className="w-full px-3.5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-medium text-gray-800 outline-none focus:ring-2 focus:ring-amber-500 transition"
                                                />
                                            </div>
                                        )}

                                        <div>
                                            <label className="block text-[11px] text-gray-500 mb-1">Catatan / Waktu Pengantaran (Opsional)</label>
                                            <input
                                                type="text"
                                                value={deliveryNote}
                                                onChange={(e) => setDeliveryNote(e.target.value)}
                                                placeholder="Contoh: Pengiriman dimulai pukul 13:00 - 16:00 WIB"
                                                className="w-full px-3.5 py-2 bg-white border border-gray-200 rounded-xl text-xs text-gray-700 outline-none focus:ring-2 focus:ring-amber-400 transition"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* 4. Tarif Ongkir Flat Luar Jam PO */}
                            <div className="bg-gradient-to-br from-gray-50 to-purple-50/20 p-4 rounded-xl border border-gray-200/70">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-9 h-9 rounded-xl flex items-center justify-center transition-colors ${outOfPoShippingActive ? 'bg-purple-600 text-white shadow-sm shadow-purple-200' : 'bg-gray-200 text-gray-500'}`}>
                                            <span className="material-icons text-lg">local_atm</span>
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-2">
                                                <p className="text-xs font-bold text-gray-800">Ongkir Flat Seller / Luar Jam PO</p>
                                                {outOfPoShippingActive && (
                                                    <span className="text-[9px] font-extrabold uppercase px-2 py-0.5 rounded-full bg-purple-100 text-purple-700">Aktif</span>
                                                )}
                                            </div>
                                            <p className="text-[10px] text-gray-500">Tetapkan tarif ongkir flat dari seller khusus produk ini</p>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setOutOfPoShippingActive(!outOfPoShippingActive)}
                                        className={`w-11 h-6 rounded-full transition-all relative ${outOfPoShippingActive ? 'bg-purple-600' : 'bg-gray-300'}`}
                                    >
                                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${outOfPoShippingActive ? 'left-6' : 'left-1'}`}></div>
                                    </button>
                                </div>

                                {outOfPoShippingActive && (
                                    <div className="mt-3.5 pt-3.5 border-t border-gray-200/60 space-y-3">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-1.5">Pilih Tipe Tarif Luar Jam PO</label>
                                            <div className="grid grid-cols-2 gap-2">
                                                <button
                                                    type="button"
                                                    onClick={() => setOutOfPoShippingType('flat')}
                                                    className={`py-2 px-2.5 rounded-xl border text-xs font-bold flex items-center justify-center gap-1.5 transition ${outOfPoShippingType === 'flat' ? 'bg-purple-100 border-purple-400 text-purple-900 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                                >
                                                    <span className="material-icons text-sm">local_atm</span>
                                                    <span>Flat Ongkir</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setOutOfPoShippingType('distance')}
                                                    className={`py-2 px-2.5 rounded-xl border text-xs font-bold flex items-center justify-center gap-1.5 transition ${outOfPoShippingType === 'distance' ? 'bg-purple-100 border-purple-400 text-purple-900 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                                >
                                                    <span className="material-icons text-sm">straighten</span>
                                                    <span>Sesuai Jarak</span>
                                                </button>
                                            </div>
                                        </div>

                                        {outOfPoShippingType === 'flat' ? (
                                            <div className="space-y-1.5">
                                                <label className="block text-xs font-semibold text-gray-700">Nominal Tarif Ongkir Flat Luar Jam PO (Rp) *</label>
                                                <div className="max-w-xs">
                                                    <CurrencyInput 
                                                        value={outOfPoShippingCost !== undefined && outOfPoShippingCost !== null ? outOfPoShippingCost : ''} 
                                                        onChange={(e) => setOutOfPoShippingCost(parseCurrency(e.target.value))} 
                                                        placeholder="Contoh: 15.000" 
                                                        className="!px-3.5 !py-2.5 !bg-white !rounded-xl !border-purple-300 !text-purple-800 !font-bold !text-xs !w-full outline-none focus:ring-2 focus:ring-purple-500"
                                                    />
                                                </div>
                                                <p className="text-[10px] text-purple-700 font-medium">
                                                    💡 Tarif ini diterapkan flat per pesanan toko Anda.
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="p-3 bg-purple-50 rounded-xl border border-purple-200 text-purple-900 text-xs space-y-1">
                                                <div className="flex items-center gap-1.5 font-bold">
                                                    <span className="material-icons text-purple-600 text-sm">info</span>
                                                    <span>Ongkir Luar Jam PO Dihitung Sesuai Jarak</span>
                                                </div>
                                                <p className="text-[11px] text-purple-800 leading-relaxed">
                                                    Pengiriman di luar jam PO akan dihitung tarifnya sesuai jarak oleh penjual / kurir dan akan dikonfirmasikan langsung kepada pembeli setelah checkout.
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 5. Fleksibilitas Pengiriman */}
                            <div className="bg-gradient-to-br from-gray-50 to-teal-50/20 p-4 rounded-xl border border-gray-200/70">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-9 h-9 rounded-xl flex items-center justify-center transition-colors ${allowDeliveryTimingChoice ? 'bg-teal-600 text-white shadow-sm shadow-teal-200' : 'bg-gray-200 text-gray-500'}`}>
                                            <span className="material-icons text-lg">calendar_month</span>
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-2">
                                                <p className="text-xs font-bold text-gray-800">Opsi Pilihan Waktu Kirim Pembeli</p>
                                                {allowDeliveryTimingChoice && (
                                                    <span className="text-[9px] font-extrabold uppercase px-2 py-0.5 rounded-full bg-teal-100 text-teal-700">Aktif</span>
                                                )}
                                            </div>
                                            <p className="text-[10px] text-gray-500">Beri pembeli opsi: Ikut jadwal saat ini/minggu ini ATAU kirim ke minggu depannya</p>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setAllowDeliveryTimingChoice(!allowDeliveryTimingChoice)}
                                        className={`w-11 h-6 rounded-full transition-all relative ${allowDeliveryTimingChoice ? 'bg-teal-600' : 'bg-gray-300'}`}
                                    >
                                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${allowDeliveryTimingChoice ? 'left-6' : 'left-1'}`}></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Rekening Sendiri Section */}
                {/* 
                <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm">
                    <div className="bg-gray-50 p-4 border-b border-gray-100 flex items-center justify-between cursor-pointer" onClick={() => setUseOwnBank(!useOwnBank)}>
                        <div className="flex items-center gap-3">
                            <span className="material-icons text-emerald-700">account_balance</span>
                            <div>
                                <p className="text-sm font-bold text-gray-800">Gunakan Rekening Sendiri</p>
                                <p className="text-[10px] text-gray-500">Salurkan pembayaran customer langsung ke rekening Anda</p>
                            </div>
                        </div>
                        <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
                            <button
                                type="button"
                                onClick={() => setUseOwnBank(!useOwnBank)}
                                className={`w-12 h-6 rounded-full transition-all relative ${useOwnBank ? 'bg-emerald-500' : 'bg-gray-300'}`}
                            >
                                <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${useOwnBank ? 'left-7' : 'left-1'}`}></div>
                            </button>
                        </div>
                    </div>

                    {useOwnBank && (
                        <div className="p-4 space-y-4 animate-slide-up">
                            {ownBankStatus !== 'none' && (
                                <div className={`p-3 rounded-xl flex items-center gap-3 text-xs font-semibold ${
                                    ownBankStatus === 'approved' ? 'bg-green-50 text-green-700 border border-green-100' :
                                    ownBankStatus === 'pending' ? 'bg-amber-50 text-amber-700 border border-amber-100' :
                                    'bg-red-50 text-red-700 border border-red-100'
                                }`}>
                                    <span className="material-icons text-lg">
                                        {ownBankStatus === 'approved' ? 'check_circle' :
                                         ownBankStatus === 'pending' ? 'pending' : 'cancel'}
                                    </span>
                                    <div>
                                        <span className="font-extrabold uppercase">Status Pengajuan: </span>
                                        {ownBankStatus === 'approved' && 'Disetujui. Customer akan membayar langsung ke rekening Anda.'}
                                        {ownBankStatus === 'pending' && 'Menunggu Persetujuan Admin (Sementara menunggu, pembayaran tetap menggunakan QRIS BAE).'}
                                        {ownBankStatus === 'rejected' && 'Ditolak (Pembayaran kembali menggunakan QRIS BAE).'}
                                    </div>
                                </div>
                            )}

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Nama Bank / QRIS *</label>
                                    <input
                                        type="text"
                                        value={ownBankName}
                                        onChange={(e) => setOwnBankName(e.target.value)}
                                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition font-semibold"
                                        placeholder="Contoh: BSI, BCA"
                                        required={useOwnBank}
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Nomor Rekening *</label>
                                    <input
                                        type="text"
                                        value={ownBankAccount}
                                        onChange={(e) => setOwnBankAccount(e.target.value)}
                                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition font-semibold"
                                        placeholder="Masukkan nomor rekening"
                                        required={useOwnBank}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Nama Pemilik Rekening *</label>
                                <input
                                    type="text"
                                    value={ownBankHolder}
                                    onChange={(e) => setOwnBankHolder(e.target.value)}
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none transition font-semibold"
                                    placeholder="Nama di buku tabungan"
                                    required={useOwnBank}
                                />
                            </div>

                            <div>
                                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">QRIS Code Penjual (Opsional)</label>
                                <div className="flex items-center gap-4">
                                    {ownQrisImagePreview && (
                                        <div className="w-20 h-20 rounded-xl overflow-hidden border border-gray-200 flex-shrink-0">
                                            <img src={ownQrisImagePreview} alt="QRIS Preview" className="w-full h-full object-cover" />
                                        </div>
                                    )}
                                    <label className="flex-1 border-2 border-dashed border-gray-200 rounded-xl px-4 py-6 flex flex-col items-center justify-center cursor-pointer hover:border-emerald-400 hover:bg-emerald-50/10 transition">
                                        <span className="material-icons text-gray-400 text-2xl mb-1">qr_code_scanner</span>
                                        <span className="text-xs font-bold text-gray-500">Upload QRIS Penjual</span>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setOwnQrisImage(file);
                                                    setOwnQrisImagePreview(URL.createObjectURL(file));
                                                }
                                            }}
                                            className="hidden"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                */}

                <div className="pt-4 border-t border-gray-100 flex gap-3">
                    <button type="button" onClick={() => setActiveTab('list')} className="flex-1 py-4 text-sm font-bold text-gray-500 bg-gray-100 hover:bg-gray-200 rounded-xl transition">Batal</button>
                    <button 
                        type="submit" 
                        disabled={savingProduct}
                        className={`flex-[2] py-4 text-sm font-bold text-white rounded-xl transition-all ${savingProduct ? 'bg-gray-300 cursor-not-allowed shadow-none' : 'bg-gradient-to-r from-emerald-500 to-teal-600 shadow-lg shadow-emerald-200 hover:shadow-xl hover:scale-[1.01]'}`}
                    >
                        {savingProduct ? (
                            <span className="flex items-center justify-center gap-2">
                                <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                                <span>Menyimpan Produk...</span>
                            </span>
                        ) : (
                            <span>{editingProduct ? 'Simpan Perubahan' : 'Simpan & Ajukan Persetujuan'}</span>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <div className="body bg-gray-100 min-h-screen">
            <Helmet><title>Pembuatan E-commerce - Barakah Economy</title></Helmet>
            <Header />
            <div className="max-w-4xl mx-auto px-3 sm:px-4 pt-20 sm:pt-24 lg:pt-8 pb-24">
                {activeTab === 'list' ? renderList() : activeTab === 'voucher' ? renderVouchers() : renderForm()}
            </div>

            {isPromoModalOpen && selectedPromoProduct && (
                <ProductPromoModal
                    isOpen={isPromoModalOpen}
                    onClose={() => { setIsPromoModalOpen(false); setSelectedPromoProduct(null); }}
                    product={selectedPromoProduct}
                    onSuccess={fetchDashboardData}
                />
            )}

            {/* Modal Transfer Kepemilikan Produk */}
            {isTransferModalOpen && transferModalProduct && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
                    <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl border border-gray-100 relative animate-slide-up">
                        <button 
                            type="button" 
                            onClick={() => { setIsTransferModalOpen(false); setTransferModalProduct(null); }} 
                            className="absolute top-4 right-4 w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition"
                        >
                            <span className="material-icons text-base">close</span>
                        </button>

                        <div className="flex items-center gap-3 mb-5">
                            <div className="w-12 h-12 rounded-2xl bg-amber-500 text-white flex items-center justify-center shadow-lg shadow-amber-200">
                                <span className="material-icons text-2xl">swap_horiz</span>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-900 text-lg">Pindah Kepemilikan Produk</h3>
                                <p className="text-xs text-gray-500">Alihkan hak kelola produk ke akun BAE lain</p>
                            </div>
                        </div>

                        {/* Product Summary Box */}
                        <div className="flex items-center gap-3 bg-gray-50 p-3.5 rounded-2xl border border-gray-200/60 mb-5">
                            <img 
                                src={getMediaUrl(transferModalProduct.thumbnail || transferModalProduct.thumbnail_url)} 
                                alt={transferModalProduct.title} 
                                className="w-14 h-14 rounded-xl object-cover border border-gray-200"
                                onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder-image.jpg'; }}
                            />
                            <div className="flex-1 min-w-0">
                                <h4 className="font-bold text-gray-800 text-sm truncate">{transferModalProduct.title}</h4>
                                <p className="text-xs font-semibold text-emerald-700 mt-0.5">Rp {formatCurrency(transferModalProduct.price)}</p>
                                <p className="text-[11px] text-gray-400">Stok: {transferModalProduct.total_stock || transferModalProduct.stock} {transferModalProduct.unit || 'pcs'}</p>
                            </div>
                        </div>

                        <form onSubmit={handleTransferOwnershipSubmit} className="space-y-4">
                            <div>
                                <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                                    Username atau Email Akun Tujuan *
                                </label>
                                <input 
                                    type="text" 
                                    value={transferTargetUser}
                                    onChange={(e) => { setTransferTargetUser(e.target.value); setTransferError(''); }}
                                    placeholder="Contoh: ahmad_fulan atau email@domain.com"
                                    required
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium focus:ring-2 focus:ring-amber-500 focus:bg-white outline-none transition"
                                />
                                <p className="text-[11px] text-gray-500 mt-1">Pastikan akun penerima sudah terdaftar aktif di web Barakah Economy.</p>
                            </div>

                            {/* Warning Box */}
                            <div className="bg-amber-50 border border-amber-200/80 rounded-2xl p-3.5 flex items-start gap-2.5">
                                <span className="material-icons text-amber-600 text-lg flex-shrink-0 mt-0.5">info</span>
                                <p className="text-xs text-amber-900 leading-relaxed">
                                    Setelah dipindahkan, produk ini akan berpindah ke toko penerima dan <b>tidak lagi berada di akun Anda</b>.
                                </p>
                            </div>

                            {transferError && (
                                <div className="bg-red-50 text-red-700 text-xs p-3 rounded-xl border border-red-200 flex items-center gap-2">
                                    <span className="material-icons text-sm">error</span>
                                    <span>{transferError}</span>
                                </div>
                            )}

                            {transferSuccess && (
                                <div className="bg-emerald-50 text-emerald-700 text-xs p-3 rounded-xl border border-emerald-200 flex items-center gap-2">
                                    <span className="material-icons text-sm">check_circle</span>
                                    <span>{transferSuccess}</span>
                                </div>
                            )}

                            <div className="flex gap-3 pt-2">
                                <button 
                                    type="button" 
                                    onClick={() => { setIsTransferModalOpen(false); setTransferModalProduct(null); }}
                                    className="flex-1 py-3 text-sm font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-xl transition"
                                >
                                    Batal
                                </button>
                                <button 
                                    type="submit" 
                                    disabled={transferLoading || !transferTargetUser.trim()}
                                    className={`flex-[2] py-3 text-sm font-bold text-white rounded-xl transition-all ${transferLoading || !transferTargetUser.trim() ? 'bg-gray-300 cursor-not-allowed' : 'bg-gradient-to-r from-amber-500 to-orange-600 shadow-md shadow-amber-200 hover:shadow-lg hover:scale-[1.01]'}`}
                                >
                                    {transferLoading ? (
                                        <span className="flex items-center justify-center gap-2">
                                            <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                                            <span>Memindahkan...</span>
                                        </span>
                                    ) : (
                                        <span>Pindahkan Sekarang</span>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Quick Bulk Stock Edit Modal (List) */}
            <QuickStockEditModal
                isOpen={isQuickStockModalOpen}
                onClose={() => setIsQuickStockModalOpen(false)}
                products={products}
                onSuccess={fetchDashboardData}
            />

            <NavigationButton />
        </div>
    );
};

export default DashboardSinergySellersPage;
